import { BlogPost } from './blogpost';
export class Category{
  id:number;
  isActive: boolean;
  name:string;
  blogs:BlogPost[]=Array<BlogPost>();
}
